import { getDatabase, ref, get } from 'firebase/database';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { app } from '../firebase';
import { getCachedEspecialidadesTemas, loadQuizBank } from '../services/rtdbCache';
import {
  getContentPath,
  isSemar,
  normalizeRank,
  resolveInstitucion,
} from '../config/institutions';

// Preguntas de muestra militar de alta calidad para garantía offline / inicio rápido
export const DEFAULT_MILITARY_QUESTIONS = [
  {
    id: 1001,
    tema_id: 101,
    materia: 'Ley Orgánica de la Armada de México (LOAM)',
    pregunta: '¿Cuál es la misión principal de la Armada de México de acuerdo con la LOAM?',
    explicacion: 'Artículo 1: Emplear el poder naval de la Federación para la defensa exterior y coadyuvar en la seguridad interior del país.',
    respuestas: [
      { id: 0, respuesta: 'Emplear el poder naval de la Federación para la defensa exterior y coadyuvar en la seguridad interior.', correcta: true },
      { id: 1, respuesta: 'Resguardar únicamente las fronteras terrestres del territorio nacional.', correcta: false },
      { id: 2, respuesta: 'Administrar los puertos comerciales sin intervención en seguridad.', correcta: false },
      { id: 3, respuesta: 'Operar como cuerpo auxiliar policial estrictamente urbano.', correcta: false }
    ]
  },
  {
    id: 1002,
    tema_id: 101,
    materia: 'Ley Orgánica de la Armada de México (LOAM)',
    pregunta: '¿Qué es la Obra Viva o Carena de un buque?',
    explicacion: 'Fundamentos de Nomenclatura Naval: La obra viva o carena es la sección del casco sumergida bajo la línea de flotación.',
    respuestas: [
      { id: 0, respuesta: 'La parte sumergida del casco por debajo de la línea de flotación.', correcta: true },
      { id: 1, respuesta: 'La cubierta superior descubierta donde se realizan maniobras.', correcta: false },
      { id: 2, respuesta: 'La estructura de gobierno situada en el puente de mando.', correcta: false },
      { id: 3, respuesta: 'La parte emergida del buque sobre la superficie del agua.', correcta: false }
    ]
  },
  {
    id: 1003,
    tema_id: 102,
    materia: 'Código de Conducta y Disciplina Militar',
    pregunta: '¿Cuál es la base fundamental sobre la que descansa la disciplina militar?',
    explicacion: 'El honor, la obediencia y el cumplimiento estricto del deber son el pilar inquebrantable de la conducta militar.',
    respuestas: [
      { id: 0, respuesta: 'La obediencia, un alto sentido del honor, de la justicia y del deber.', correcta: true },
      { id: 1, respuesta: 'El temor a la sanción administrativa de los superiores.', correcta: false },
      { id: 2, respuesta: 'La antigüedad exclusivamente acumulada en el escalafón.', correcta: false },
      { id: 3, respuesta: 'El criterio individual sin subordinación al mando.', correcta: false }
    ]
  },
  {
    id: 1004,
    tema_id: 102,
    materia: 'Código de Conducta y Disciplina Militar',
    pregunta: '¿Qué principio rige el uso de la fuerza en operaciones de Seguridad Interior?',
    explicacion: 'Principios de Uso de la Fuerza: Absoluta necesidad, legalidad, prevención, proporcionalidad y oportunidad.',
    respuestas: [
      { id: 0, respuesta: 'Legalidad, absoluta necesidad, proporcionalidad, prevención y oportunidad.', correcta: true },
      { id: 1, respuesta: 'Uso discrecional según la apreciación sin límite de fuerza.', correcta: false },
      { id: 2, respuesta: 'Aplicación masiva de fuerza preventiva sin previa advertencia.', correcta: false },
      { id: 3, respuesta: 'Subordinación absoluta a las autoridades civiles locales.', correcta: false }
    ]
  },
  {
    id: 1005,
    tema_id: 103,
    materia: 'Derechos Humanos y DIH',
    pregunta: '¿Cuál es el objetivo primordial del Derecho Internacional Humanitario (DIH) en conflictos armados?',
    explicacion: 'El DIH protege a las personas que no participan o han dejado de participar en las hostilidades y limita los medios de combate.',
    respuestas: [
      { id: 0, respuesta: 'Limitar los medios y métodos de combate y proteger a quienes no participan en las hostilidades.', correcta: true },
      { id: 1, respuesta: 'Prohibir la existencia de fuerzas armadas en tiempos de paz.', correcta: false },
      { id: 2, respuesta: 'Sustituir las leyes penales internas de cada nación soberana.', correcta: false },
      { id: 3, respuesta: 'Permitir ataques indiscriminados cuando sea operativamente conveniente.', correcta: false }
    ]
  },
  {
    id: 1006,
    tema_id: 103,
    materia: 'Derechos Humanos y DIH',
    pregunta: '¿Qué autoridad evalúa y garantiza la protección de los derechos fundamentales en operativos navales y militares?',
    explicacion: 'Los mandos militares están obligados a hacer respetar la Constitución y los Tratados Internacionales en materia de DDHH.',
    respuestas: [
      { id: 0, respuesta: 'Todos los mandos y personal de la institución en estricto apego a la Constitución y Tratados.', correcta: true },
      { id: 1, respuesta: 'Únicamente observadores internacionales no gubernamentales.', correcta: false },
      { id: 2, respuesta: 'Solo la fiscalía civil una vez concluidas las operaciones.', correcta: false },
      { id: 3, respuesta: 'Ninguna autoridad durante estados de excepción.', correcta: false }
    ]
  },
  {
    id: 1007,
    tema_id: 104,
    materia: 'Legislación de la Guardia Nacional',
    pregunta: '¿Cuál es la naturaleza jurídica de la Guardia Nacional de acuerdo con su Ley Orgánica?',
    explicacion: 'Institución de seguridad pública de carácter civil, disciplinada y profesional.',
    respuestas: [
      { id: 0, respuesta: 'Institución de seguridad pública, de carácter civil, disciplinada y profesional.', correcta: true },
      { id: 1, respuesta: 'Cuerpo de reserva privada sin adiestramiento táctico.', correcta: false },
      { id: 2, respuesta: 'Comisión temporal de policía municipal sin mando centralizado.', correcta: false },
      { id: 3, respuesta: 'Fuerza armada auxiliar sin funciones de investigación.', correcta: false }
    ]
  },
  {
    id: 1008,
    tema_id: 105,
    materia: 'Mando y Liderazgo Naval/Militar',
    pregunta: '¿En qué consiste el principio del Mando Operativo?',
    explicacion: 'Mando: Autoridad ejercida sobre subordinados en virtud del grado, cargo o comisión asignada.',
    respuestas: [
      { id: 0, respuesta: 'Es la autoridad legal y moral que ejerce un militar sobre los subordinados.', correcta: true },
      { id: 1, respuesta: 'Es una facultad compartida democráticamente mediante votación de tropa.', correcta: false },
      { id: 2, respuesta: 'Es la recomendación técnica que no requiere acatamiento inmediato.', correcta: false },
      { id: 3, respuesta: 'Es la potestad exclusiva de los tribunales militares.', correcta: false }
    ]
  }
];

// Normalizar estructura de preguntas para manejo seguro
export function normalizeQuestion(q) {
  if (!q) return q;
  const preguntaText = q.pregunta || q.question || '';
  const explicacionText = q.explicacion || q.explanation || '';
  let respuestasArray = [];

  if (Array.isArray(q.respuestas)) {
    respuestasArray = q.respuestas.filter(r => r !== null && r !== undefined).map((r, idx) => {
      if (typeof r === 'string') {
        return { id: idx, respuesta: r, correcta: false };
      }
      return {
        id: r?.id !== undefined ? r.id : idx,
        respuesta: r?.respuesta || r?.text || '',
        correcta: r?.correcta === true || r?.correcta === 1 || String(r?.correcta) === "1" || String(r?.correcta).toLowerCase() === "true"
      };
    });
  } else if (q.respuestas && typeof q.respuestas === 'object') {
    respuestasArray = Object.values(q.respuestas).filter(r => r !== null && r !== undefined).map((r, idx) => {
      if (typeof r === 'string') {
        return { id: idx, respuesta: r, correcta: false };
      }
      return {
        id: r?.id !== undefined ? r.id : idx,
        respuesta: r?.respuesta || r?.text || '',
        correcta: r?.correcta === true || r?.correcta === 1 || String(r?.correcta) === "1" || String(r?.correcta).toLowerCase() === "true"
      };
    });
  } else if (Array.isArray(q.opciones || q.options)) {
    const options = q.opciones || q.options;
    const correctIdx = q.correctIndex !== undefined ? q.correctIndex : (q.correctAnswer !== undefined ? q.correctAnswer : 0);
    respuestasArray = options.map((opt, idx) => ({
      id: idx,
      respuesta: typeof opt === 'string' ? opt : (opt?.respuesta || opt?.text || ''),
      correcta: idx === parseInt(correctIdx)
    }));
  }

  return {
    ...q,
    pregunta: preguntaText,
    explicacion: explicacionText,
    respuestas: respuestasArray
  };
}

// Extraer texto de la respuesta correcta de forma 100% segura frente a valores nulos o tipos inconsistentes
export function getCorrectAnswerText(card) {
  if (!card) return 'Sin respuesta disponible.';
  
  if (Array.isArray(card.respuestas)) {
    const valid = card.respuestas.filter(r => r !== null && r !== undefined);
    const correct = valid.find(r => typeof r === 'object' && (r?.correcta === true || r?.correcta === 1 || String(r?.correcta) === "1" || String(r?.correcta).toLowerCase() === "true"));
    if (correct) return correct.respuesta || correct.text || '';
    const first = valid[0];
    if (typeof first === 'object' && first !== null) return first.respuesta || first.text || '';
    if (typeof first === 'string') return first;
  } else if (typeof card.respuestas === 'object' && card.respuestas !== null) {
    const entries = Object.values(card.respuestas).filter(r => r !== null && r !== undefined);
    const correct = entries.find(r => typeof r === 'object' && (r?.correcta === true || r?.correcta === 1 || String(r?.correcta) === "1" || String(r?.correcta).toLowerCase() === "true"));
    if (correct) return correct.respuesta || correct.text || '';
    const first = entries[0];
    if (typeof first === 'object' && first !== null) return first.respuesta || first.text || '';
    if (typeof first === 'string') return first;
  }

  return 'Respuesta registrada en la clave oficial.';
}

// Servicio unificado para cargar preguntas y materias
// Cache en memoria por sesion e institución: evita re-normalizar todo el banco
// cada vez que se abre Debilidades / Flashcards / Modo Guardia en la misma visita.
const _studyBundleCaches = new Map();
const _studyBundlePromises = new Map();
const _guardiaCache = new Map();
const _guardiaInFlight = new Map();
const GUARDIA_CACHE_TTL = 5 * 60 * 1000;

export function invalidateStudyQuestionsCache() {
  _studyBundleCaches.clear();
  _studyBundlePromises.clear();
  _guardiaCache.clear();
  _guardiaInFlight.clear();
}

async function loadStudyBundle(institucion = 'SEMAR') {
  const resolved = resolveInstitucion(institucion);
  if (_studyBundleCaches.has(resolved)) return _studyBundleCaches.get(resolved);
  if (_studyBundlePromises.has(resolved)) return _studyBundlePromises.get(resolved);

  const promise = (async () => {
    let allQuestions = [];
    let materias = [];

    try {
      const bank = await loadQuizBank({ institucion: resolved });
      materias = bank.temas || [];

      if (bank.preguntas.length > 0) {
        const materiasMap = {};
        materias.forEach((tema) => {
          if (tema && tema.id !== undefined && tema.id !== null) {
            materiasMap[tema.id] = tema.nombre || `Materia #${tema.id}`;
          }
        });

        allQuestions = bank.preguntas.map((question) => {
          const materiaName = materiasMap[question.tema_id] || question.materia || question.tema_nombre || 'Legislación y Conocimientos General';
          return normalizeQuestion({
            ...question,
            materia: materiaName,
          });
        });
        console.log(`[studyData] 📦 Preguntas cargadas desde caché (${resolved}): ${allQuestions.length}`);
      }
    } catch (err) {
      console.warn('No se pudo cargar el banco de preguntas:', err);
    }

    // Las preguntas de muestra son navales: solo aplican como respaldo de SEMAR.
    if (allQuestions.length < 5 && isSemar(resolved)) {
      allQuestions = [...allQuestions, ...DEFAULT_MILITARY_QUESTIONS.map(normalizeQuestion)];
    }

    return { questions: allQuestions, temas: materias };
  })();

  _studyBundlePromises.set(resolved, promise);
  try {
    const bundle = await promise;
    _studyBundleCaches.set(resolved, bundle);
    return bundle;
  } finally {
    _studyBundlePromises.delete(resolved);
  }
}

export async function loadStudyQuestions(institucion = 'SEMAR') {
  const bundle = await loadStudyBundle(institucion);
  return bundle.questions;
}

// Cargar y guardar progreso de Flashcards
export function getFlashcardProgress() {
  try {
    const saved = localStorage.getItem('vortex_flashcard_progress');
    return saved ? JSON.parse(saved) : {};
  } catch (e) {
    return {};
  }
}

export function saveFlashcardProgress(cardId, level) {
  // level: 'EASY' (Verde), 'MEDIUM' (Amarillo), 'HARD' (Rojo)
  try {
    const current = getFlashcardProgress();
    current[cardId] = {
      level,
      timestamp: Date.now(),
    };
    localStorage.setItem('vortex_flashcard_progress', JSON.stringify(current));
  } catch (e) {
    console.error('Error guardando progreso de flashcard:', e);
  }
}

// Cargar e integrar mapa de calor de debilidades
export function getWeaknessHeatmap(allQuestions = []) {
  const flashcardProgress = getFlashcardProgress();
  const historyRaw = localStorage.getItem('vortex_quiz_history') || localStorage.getItem('quiz_results_history');
  let quizHistory = [];
  try {
    if (historyRaw) quizHistory = JSON.parse(historyRaw);
  } catch (e) {}

  // Agrupar preguntas por materia
  const materiaMap = {};

  allQuestions.forEach(q => {
    const mat = q.materia || 'Legislación General';
    if (!materiaMap[mat]) {
      materiaMap[mat] = {
        materia: mat,
        totalQuestions: 0,
        easyCount: 0,
        mediumCount: 0,
        hardCount: 0,
        quizCorrect: 0,
        quizTotal: 0,
        questions: []
      };
    }

    materiaMap[mat].totalQuestions++;
    materiaMap[mat].questions.push(q);

    // Revisar progreso de flashcard
    const cardStatus = flashcardProgress[q.id];
    if (cardStatus) {
      if (cardStatus.level === 'EASY') materiaMap[mat].easyCount++;
      else if (cardStatus.level === 'MEDIUM') materiaMap[mat].mediumCount++;
      else if (cardStatus.level === 'HARD') materiaMap[mat].hardCount++;
    }
  });

  // Procesar historial de quizzes si existen
  if (Array.isArray(quizHistory)) {
    quizHistory.forEach(quiz => {
      const mat = quiz.materia || quiz.quizType || 'Legislación General';
      if (materiaMap[mat]) {
        materiaMap[mat].quizCorrect += (quiz.score || 0);
        materiaMap[mat].quizTotal += (quiz.totalQuestions || 0);
      }
    });
  }

  // Calcular porcentaje de dominio y color de semáforo
  return Object.values(materiaMap).map(m => {
    const evaluated = m.easyCount + m.mediumCount + m.hardCount + m.quizTotal;
    
    let percentage = 0;
    if (evaluated > 0) {
      const scoreFromCards = (m.easyCount * 1.0) + (m.mediumCount * 0.5);
      const totalPointsPossible = (m.easyCount + m.mediumCount + m.hardCount) + m.quizTotal;
      const totalPointsEarned = scoreFromCards + m.quizCorrect;
      percentage = Math.round((totalPointsEarned / (totalPointsPossible || 1)) * 100);
    } else {
      // Sin practicar aún
      percentage = 0;
    }

    // Código de semáforo
    let status = 'RED'; // 🔴 < 60%
    let statusText = 'Atención Urgente';
    let badgeColor = '#ff4d4d';

    if (percentage >= 85) {
      status = 'GREEN'; // 🟢 >= 85%
      statusText = 'Dominado';
      badgeColor = '#10b981';
    } else if (percentage >= 60) {
      status = 'YELLOW'; // 🟡 60-84%
      statusText = 'En Progreso';
      badgeColor = '#f59e0b';
    } else if (evaluated === 0) {
      status = 'RED';
      statusText = 'Por Iniciar';
      badgeColor = '#ef4444';
    }

    return {
      ...m,
      percentage,
      status,
      statusText,
      badgeColor,
      evaluated
    };
  }).sort((a, b) => a.percentage - b.percentage); // Ordenar por menor porcentaje primero (debilidades principales)
}

// ─────────────────────────────────────────────────────────────
// Modo Guardia: cargador de preguntas CONSCIENTE DEL PERFIL
// Consulta los 'conocimientos específicos' (Área 3) del usuario
// según su grado/jerarquía y fusiona sus quizzes personales.
// ─────────────────────────────────────────────────────────────

// Normaliza una cadena para comparar jerarquías (misma lógica que SimuladorExamen)
function normalizeJerarquiaKey(str = '') {
  return str
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[_\s]+DE[_\s]+/g, '_')
    .trim()
    .replace(/[_\s]+/g, '_');
}

// Mapea el texto del grado del usuario a la clave de jerarquía del simulador
export function mapGradoToJerarquiaKey(grado) {
  const g = (grado || '').toLowerCase().replace(/_/g, ' ').replace(/\./g, ' ');

  if (g.includes('marinero') || g.includes('mro')) return 'marinero';
  if (g.includes('cabo') || g.includes('cbo')) return 'cabo';
  if (g.includes('tercer maestre') || g.includes('3rm') || g.includes('3er')) return 'tercer_maestre';
  if (g.includes('segundo maestre') || g.includes('2dm') || g.includes('2do')) return 'segundo_maestre';
  if (g.includes('primer maestre') || g.includes('1rm') || g.includes('1er')) return 'primer_maestre';
  if (g.includes('teniente corbeta') || g.includes('teniente de corbeta') || g.includes('tte corb') || g.includes('ttc')) return 'teniente_corbeta';
  if (g.includes('teniente fragata') || g.includes('teniente de fragata') || g.includes('tte frag') || g.includes('ttf')) return 'teniente_fragata';
  if (g.includes('teniente navío') || g.includes('teniente navio') || g.includes('teniente de navío') || g.includes('tte nav') || g.includes('ttn')) return 'teniente_navio';
  if (g.includes('capitán corbeta') || g.includes('capitan corbeta') || g.includes('capitán de corbeta') || g.includes('cap corb') || g.includes('ctc')) return 'capitan_corbeta';
  return null;
}

const GUARDIA_JERARQUIA_SEARCH = {
  marinero: 'MRO',
  cabo: 'CBO',
  tercer_maestre: '3RM',
  segundo_maestre: '2DM',
  primer_maestre: '1RM',
  teniente_corbeta: 'TTE.CORB.',
  teniente_fragata: 'TTE.FRAG.',
  teniente_navio: 'TTE.NAV.',
  capitan_corbeta: 'CAP.CORB.'
};

const GUARDIA_JERARQUIA_NOMBRE = {
  marinero: 'Marinero',
  cabo: 'Cabo',
  tercer_maestre: 'Tercer Maestre',
  segundo_maestre: 'Segundo Maestre',
  primer_maestre: 'Primer Maestre',
  teniente_corbeta: 'Teniente de Corbeta',
  teniente_fragata: 'Teniente de Fragata',
  teniente_navio: 'Teniente de Navío',
  capitan_corbeta: 'Capitán de Corbeta'
};

const HIERARCHY_TO_RTDB = {
  'marinero': 'MARINERO',
  'cabo': 'CABO',
  'tercer_maestre': 'TERCER_MAESTRE',
  'segundo_maestre': 'SEGUNDO_MAESTRE',
  'primer_maestre': 'PRIMER_MAESTRE',
  'suboficial': 'SUBOFICIAL',
  'teniente_corbeta': 'TENIENTE_CORBETA',
  'teniente_fragata': 'TENIENTE_FRAGATA',
  'teniente_navio': 'TENIENTE_NAVIO',
  'capitan_corbeta': 'CAPITAN_CORBETA'
};

// Extrae las preguntas de un cuestionario de especialidad (array u objeto)
function extraerPreguntasDeCuestionario(cuestionario) {
  if (!cuestionario) return [];
  const preguntasRaw = cuestionario.preguntas;
  if (!preguntasRaw) return [];
  const preguntasArray = Array.isArray(preguntasRaw)
    ? preguntasRaw
    : Object.entries(preguntasRaw).map(([id, p]) => ({ id, ...(p && typeof p === 'object' ? p : {}) }));
  return preguntasArray.filter(Boolean);
}

// Normaliza el nodo especialidades_temas a una lista homogénea.
function normalizeEspecialidades(raw) {
  if (Array.isArray(raw)) return raw;
  if (!raw || typeof raw !== 'object') return [];
  return Object.entries(raw).map(([temaId, temaObj]) => ({
    temaId: parseInt(temaId, 10),
    nombre: temaObj?.nombre || `Especialidad Tema ${temaId}`,
    cuestionarios: temaObj?.cuestionarios || {},
  }));
}

function appendEspecialidades(especificos, temasEspecialidad) {
  let temasCount = 0;
  temasEspecialidad.forEach((temaObj) => {
    if (!temaObj || !temaObj.cuestionarios) return;
    const temaId = temaObj.temaId;
    const materia = `🎯 ${temaObj.nombre || `Especialidad Tema ${temaId}`}`;
    Object.entries(temaObj.cuestionarios).forEach(([quizzId, quizzObj]) => {
      extraerPreguntasDeCuestionario(quizzObj).forEach((p, idx) => {
        const norm = normalizeQuestion({ id: p.id !== undefined ? p.id : idx, ...p });
        especificos.push({
          ...norm,
          id: `espec_${temaId}_${quizzId}_${norm.id}`,
          materia,
          isSpecialty: true,
          tema_id: temaId,
        });
      });
    });
    if (Object.keys(temaObj.cuestionarios).length > 0) temasCount++;
  });
  return temasCount;
}

// Quizzes personales del usuario: cada uno se muestra como su propia materia.
async function loadPersonalQuestions(firestore, uid) {
  if (!uid) return [];
  try {
    const quizzesRef = collection(firestore, 'user_quizzes', uid, 'quizzes');
    const quizzesSnap = await getDocs(quizzesRef);
    const quizzes = quizzesSnap.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));

    const quizQuestionSnaps = await Promise.all(
      quizzes.map((quiz) =>
        getDocs(collection(firestore, 'user_quizzes', uid, 'quizzes', quiz.id, 'questions')).catch(() => null)
      )
    );

    const personales = [];
    quizzes.forEach((quiz, quizIdx) => {
      const qSnap = quizQuestionSnaps[quizIdx];
      if (!qSnap) return;
      const quizAreaId = quiz.areaId || quiz.area_id;
      const materiaPersonal = quiz.temaName || quiz.name || '🎯 Quizz Personal';
      qSnap.docs.forEach((qDoc) => {
        const data = qDoc.data();
        const normalized = normalizeQuestion({
          ...data,
          id: qDoc.id,
          pregunta: data.pregunta || data.question || '',
          explicacion: data.explicacion || data.explanation || '',
        });
        personales.push({
          ...normalized,
          id: `personal_${quiz.id}_${qDoc.id}`,
          isPersonal: true,
          quizId: quiz.id,
          _quizAreaId: quizAreaId,
          materia: `🗂️ ${materiaPersonal}`,
        });
      });
    });
    return personales;
  } catch (err) {
    console.warn('[Modo Guardia] No se pudieron cargar los quizzes personales:', err);
    return [];
  }
}

// Carga datos específicos del Modo Guardia:
//  - preguntas base (áreas 1 y 2) filtradas por el grado del usuario
//  - los 'conocimientos específicos' (Área 3) desde el nodo especialidades_temas
//    según su jerarquía / cuerpo / especialidad, cada tema como materia seleccionable
//  - fusiona las preguntas de sus quizzes personales (cada uno como materia)
export async function loadGuardiaQuestions(profileData, uid) {
  const institucion = resolveInstitucion(profileData?.institucion);
  const semar = isSemar(institucion);
  const grado = profileData?.grado || profileData?.jerarquia || profileData?.hierarchy || '';
  const cuerpo = profileData?.corps || profileData?.cuerpo || profileData?.cuerpoServicio || '';
  const especialidad = profileData?.specialty || profileData?.especialidad || '';
  const jerarquiaKey = semar ? mapGradoToJerarquiaKey(grado) : null;
  const hierarchyCode = semar
    ? (jerarquiaKey ? (HIERARCHY_TO_RTDB[jerarquiaKey] || grado.toUpperCase().replace(/\./g, '').replace(/\s+/g, '_')) : '')
    : (normalizeRank(grado).replace(/\s+/g, '_') || 'TODOS');
  const corpsCode = cuerpo;
  const specialtyCode = especialidad;

  const cacheKey = `${institucion}|${uid || 'anon'}|${hierarchyCode}|${corpsCode}|${specialtyCode}`;
  const cached = _guardiaCache.get(cacheKey);
  if (cached && Date.now() - cached.timestamp < GUARDIA_CACHE_TTL) {
    return cached.data;
  }
  if (_guardiaInFlight.has(cacheKey)) {
    return _guardiaInFlight.get(cacheKey);
  }

  const request = (async () => {
    const rtdb = getDatabase(app);
    const firestore = getFirestore(app);

    const temaCoincideConGrado = (tema) => {
      if (!tema || !tema.grados) return true;
      const tokens = String(tema.grados).split(',').map((t) => t.trim());
      if (tokens.some((t) => t.toUpperCase() === 'TODOS')) return true;
      if (!semar) {
        const target = normalizeRank(grado);
        return Boolean(target) && tokens.some((t) => normalizeRank(t) === target);
      }
      if (!jerarquiaKey) return true;
      const searchRank = GUARDIA_JERARQUIA_SEARCH[jerarquiaKey];
      const nombreNorm = normalizeJerarquiaKey(GUARDIA_JERARQUIA_NOMBRE[jerarquiaKey]);
      const searchNorm = normalizeJerarquiaKey(searchRank);
      return tokens.some((t) => {
        const up = t.toUpperCase();
        if (up === searchRank.toUpperCase()) return true;
        if (up === searchRank.replace(/_/g, ' ')) return true;
        const norm = normalizeJerarquiaKey(t);
        return norm === searchNorm || norm === nombreNorm || norm === normalizeJerarquiaKey(jerarquiaKey.replace(/_/g, ' '));
      });
    };

    // Banco base, especialidades y quizzes personales en paralelo.
    const specialtyRequest = (hierarchyCode && corpsCode && specialtyCode)
      ? getCachedEspecialidadesTemas(hierarchyCode, corpsCode, specialtyCode, institucion).catch((err) => {
          console.warn('[Modo Guardia] No se pudieron cargar los conocimientos específicos:', err);
          return [];
        })
      : Promise.resolve([]);

    const [bundle, cachedEspec, personales] = await Promise.all([
      loadStudyBundle(institucion),
      specialtyRequest,
      loadPersonalQuestions(firestore, uid),
    ]);

    const temas = bundle.temas || [];
    const preguntasBase = bundle.questions || [];

    // Filtrar las preguntas base según el perfil. En SEMAR las áreas 1 y 2 son el
    // tronco común y el área 3 es la especialidad; GN/SEDENA reparten el tronco
    // común en todas sus áreas.
    let filtradas = preguntasBase;
    if ((jerarquiaKey || !semar) && temas.length > 0) {
      const temasPermitidos = semar
        ? temas.filter((tema) => Number(tema.area_id) === 1 || Number(tema.area_id) === 2)
        : temas;
      const temasDelGrado = temasPermitidos.filter(temaCoincideConGrado);
      const allowedIds = new Set(temasDelGrado.map((tema) => String(tema.id)));
      filtradas = preguntasBase.filter(
        (question) => question.tema_id !== undefined && question.tema_id !== null && allowedIds.has(String(question.tema_id))
      );
    }

    // Conocimientos específicos desde especialidades_temas según el perfil.
    let especificos = [];
    let especificosTemasCount = 0;
    if (hierarchyCode && corpsCode && specialtyCode) {
      let temasEspecialidad = cachedEspec;
      if (temasEspecialidad.length === 0) {
        try {
          const precedencia = getContentPath(
            institucion,
            `especialidades_temas/${hierarchyCode}/${corpsCode}/${specialtyCode}/temas`
          );
          const snap = await get(ref(rtdb, precedencia));
          if (snap.exists()) temasEspecialidad = normalizeEspecialidades(snap.val());
        } catch (err) {
          console.warn('[Modo Guardia] No se pudieron cargar los conocimientos específicos:', err);
        }
      }
      especificosTemasCount = appendEspecialidades(especificos, temasEspecialidad);
      if (temasEspecialidad.length > 0) {
        console.log(`[Modo Guardia] 🎯 ${especificos.length} preguntas específicas de ${especificosTemasCount} temas (${institucion})`);
      }
    }

    // GN/SEDENA: el árbol de especialidades puede replicar el banco base.
    // Se conserva la primera aparición para no duplicar tarjetas.
    let baseYEspecificos = [...filtradas, ...especificos];
    if (!semar) {
      const seen = new Set();
      baseYEspecificos = baseYEspecificos.filter((question) => {
        const key = normalizeRank(question?.pregunta || '').slice(0, 200);
        if (!key) return true;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    return {
      questions: [...baseYEspecificos, ...personales],
      jerarquiaKey,
      jerarquiaNombre: semar ? (jerarquiaKey ? GUARDIA_JERARQUIA_NOMBRE[jerarquiaKey] : null) : (grado || null),
      especificosCount: Math.max(0, baseYEspecificos.length - filtradas.length) + personales.length,
      filtradoPorPerfil: (!!jerarquiaKey || !semar) && temas.length > 0,
    };
  })();

  _guardiaInFlight.set(cacheKey, request);
  try {
    const data = await request;
    _guardiaCache.set(cacheKey, { data, timestamp: Date.now() });
    return data;
  } finally {
    _guardiaInFlight.delete(cacheKey);
  }
}
